/* ===== data/story.js — 장 · 세션 · 단말기 · 석판 · 대화 ===== */
import { T } from '../data.js';
/* data.js 에서 나눈 표 — data.js 다음 층에서 소스 순서대로 읽힌다 */

/* ---------------- 스토리 ---------------- */
/* obj types: kill(target,n) / mine(tile,n) / collect(item,n) / talk(npc) / depth(y) / boss(target) /
   craft(item) / and(parts — 이어서 하는 일: 모으고 → 만들기. 전부 끝나야 한 칸) */
export const CHAPTERS: ChapterDef[] = [
  {
    id: 0, title: '떨어진 별', sub: '서 장', art: 'chapter_0_fallen_star',
    line: '별이 부서진 밤',
    intro: '한밤중에 하늘이 갈라졌다.\n' +
      '떨어진 것은 돌이 아니었다. 부딪히기 직전, 그것은 분명히 몸을 뒤틀어 피하려 했다.\n' +
      '무언가로부터 도망치던 중이었다.\n\n' +
      '그것은 다섯 갈래 빛으로 부서져 흩어졌고, 그중 한 조각의 빛이 네 오른손에 박혔다.\n' +
      '눈을 떴을 때 세계는 색을 잃어가고 있었다. 사람들은 그것을 잿빛이라 불렀다.',
    basics: [
      { type: 'and', parts: [{ type: 'collect', item: 'wood', n: 10 }, { type: 'craft', item: 'plank' }],
        t: '무너진 것을 다시 세우려면', task: '나무 10개 → 판자 만들기', verb: 'craft' },
      { type: 'kill', target: 'slime', n: 3, t: '잿빛이 걸어 다니는 것을 처음 본다', task: '잿빛 슬라임 3마리', verb: 'kill' },
      { type: 'collect', item: 'stone', n: 20, t: '바람을 막을 벽 한 줄', task: '돌 20개', verb: 'gather' }
    ],
    needBasics: 2,
    require: [],
    goal: { type: 'talk', npc: 'elara', t: '살아 있는 사람을 찾는다', task: '엘라라와 대화', verb: 'talk' },
    rw: { xp: 150, gold: 40, items: [['potion_hp_small', 3], ['torch', 20]] },
    outro: '엘라라: "살아 있는 사람을 본 게 얼마 만인지…"\n' +
      '"…네 오른손. 빛나고 있는 거, 알고는 있니?"'
  },
  {
    id: 1, title: '잿빛 야영지', sub: '제 1 장', art: 'chapter_1_ash_village',
    line: '혼자이지 않기를 꿈꾼 것',
    intro: '미라가 알려준 사실은 이렇다.\n' +
      '별 조각은 홀로 남으면 잠들고, 잠들면 꿈을 꾼다. 그리고 그 꿈이 주변 물질에게\n' +
      '"너는 무엇이었지?"를 잊게 만든다. 색이 빠지고, 형태가 흐려지고, 결국 아무것도 아닌 것이 된다.\n' +
      '그게 잿빛의 정체다. 재가 아니라, 세계가 자기 정의를 잊는 것.\n\n' +
      '여기는 마을이 아니다. 무너진 마을에서 걸어 나온 넷이 천막을 세운 자리다.\n' +
      '엘라라는 이곳을 베이스캠프라고 부른다. 돌아올 곳이 있어야 나갈 수 있다면서.\n\n' +
      '첫 번째 조각은 캠프 동쪽 늪에 떨어졌다. 그것은 혼자이지 않기를 꿈꿨고,\n' +
      '그래서 끝없이 갈라지기 시작했다.',
    basics: [
      { type: 'and', parts: [{ type: 'mine', tile: T.COPPER, n: 12 }, { type: 'craft', item: 'sword_copper' }],
        t: '맨손으로는 안 된다', task: '구리 광맥 12번 → 구리 장검 벼리기', verb: 'dig' },
      { type: 'kill', target: 'slime', n: 8, t: '하나가 둘이 되기 전에', task: '갈라진 것 8마리', verb: 'kill' },
      { type: 'explore', ruin: 'mine', t: '사람들이 두고 간 갱도', task: '버려진 광산 탐험', verb: 'explore' }
    ],
    needBasics: 2,
    require: ['dig'],
    goal: { type: 'boss', target: 'king_slime', t: '웅덩이가 식을 때까지', task: '잿물 군체 토벌', verb: 'boss' },
    rw: { xp: 480, gold: 180, items: [['helm_copper', 1], ['potion_hp_small', 5]] },
    outro: '잿물이 식어 갈라지자 녹슨 투구 밑에서 손바닥만 한 심장이 굴러 나왔다. 아직 미지근하다.\n\n' +
      '노인: "그게 무엇을 꿈꿨는지 알겠나. …외롭지 않기를 꿈꿨어."\n' +
      '미라: "하나야. 다섯 중에 하나."'
  },
  {
    id: 2, title: '뼈가 쌓인 곳', sub: '제 2 장', art: 'chapter_2_bone_pit',
    line: '잠든 것들의 꿈을 대신 꾼 조각',
    intro: '두 번째 조각은 캠프가 서기 훨씬 전부터 있던 묘실에 떨어졌다.\n' +
      '조각은 제 꿈을 꾸지 않았다. 그 아래 잠들어 있던 것들의 꿈을 대신 꿨다.\n' +
      '그래서 그것들이 일어났다.\n\n' +
      '보린이 무기부터 챙기라고 했다. 아래는 깊고, 조각은 가장 아래에 있다.',
    basics: [
      { type: 'depth', y: 170, t: '아래로 갈수록 조용해진다', task: '지하 450m', verb: 'depth' },
      { type: 'kill', target: 'skeleton', n: 10, t: '누운 자리에서 일어난 것들', task: '무덤지기 10마리', verb: 'kill' },
      { type: 'kill', target: 'spider', n: 8, t: '갱도를 다시 차지한 것', task: '동굴 거미 8마리', verb: 'kill' },
      { type: 'kill', target: 'minerghost', n: 5, t: '아직 퇴근하지 못한 사람들', task: '광부의 유령 5마리', verb: 'kill' }
    ],
    needBasics: 2,
    require: ['depth'],
    goal: { type: 'boss', target: 'bone_lord', t: '뼈 위에 앉은 것을 내린다', task: '뼈 오르간 토벌', verb: 'boss' },
    rw: { xp: 1600, gold: 600, items: [['ring_vigor', 1], ['potion_hp_small', 8]] },
    outro: '뼈 오르간은 마지막 관이 꺼지기 직전, 조각을 제 갈비뼈 사이에서 꺼내 네 쪽으로 밀어주었다.\n\n' +
      '"…고맙다. 꿈이 너무 길었어."\n' +
      '그는 재가 되기 전에 한 마디를 더 남겼다. "셋째는 스스로 걸어올 것이다."'
  },
  {
    id: 3, title: '부패한 숲', sub: '제 3 장', art: 'chapter_3_corrupt_forest',
    line: '굶주림을 꿈꾼 것',
    intro: '세 번째 조각은 동쪽 숲 한가운데 떨어져 굶주림을 꿈꿨다.\n' +
      '그래서 숲이 먹기 시작했다. 나무가 짐승을 먹고, 짐승이 흙을 먹고,\n' +
      '흙이 다시 나무를 먹는다. 멈추지 않는다. 배가 부르지 않으니까.\n\n' +
      '한가운데 나무 천장에 잿빛 고치가 하나 매달려 있다. 속에서 불빛이 숨 쉰다. 그게 조각을 삼킨 자리다.',
    basics: [
      { type: 'collect', item: 'corrupt_ess', n: 14, t: '흙까지 물든 것을 걷어 낸다', task: '부패의 정수 14개', verb: 'gather' },
      { type: 'kill', target: 'shadoweye', n: 8, t: '보고 있는 것을 먼저 없앤다', task: '그림자 눈 8마리', verb: 'kill' },
      { type: 'kill', target: 'crawler', n: 8, t: '사냥하던 것이 사냥당한다', task: '부패한 사냥꾼 8마리', verb: 'kill' },
      { type: 'kill', target: 'corrupttree', n: 5, t: '뿌리부터 굶주려 있다', task: '부패한 나무 5그루', verb: 'kill' }
    ],
    needBasics: 2,
    require: ['gather'],
    goal: { type: 'boss', target: 'corrupt_heart', t: '굶주림의 한가운데', task: '잿빛 고치 토벌', verb: 'boss' },
    rw: { xp: 4000, gold: 1400, items: [['mythril_ore', 20], ['potion_hp', 5]] },
    outro: '나방의 불이 꺼지자 숲이 처음으로 숨을 뱉었다. 들이쉬는 게 아니라, 뱉는 것을.\n\n' +
      '미라: "굶주림은 병이 아니야. 그냥, 아무도 먹여주지 않은 거지."'
  },
  {
    id: 4, title: '서리 왕좌', sub: '제 4 장', art: 'chapter_4_frost_throne',
    line: '조각을 재우지 않은 사람',
    intro: '네 번째 조각은 사람이 먼저 주웠다.\n\n' +
      '실비아는 그것을 재우지 않았다. 깨어 있는 조각을 맨손에 쥔 채 서른 해를 버텼고,\n' +
      '그 대가로 그녀가 닿는 모든 것이 얼었다. 설원은 원래 설원이 아니었다.\n\n' +
      '그녀는 실패한 게 아니다. 성공한 유일한 사람이고, 그게 그녀를 죽이고 있다.\n' +
      '미라는 스승을 만나러 가는 길 내내 아무 말도 하지 않았다.',
    basics: [
      { type: 'collect', item: 'frost_core', n: 12, t: '얼지 않으려면 불씨가 있어야 한다', task: '서리 결정 12개', verb: 'gather' },
      { type: 'kill', target: 'frostling', n: 10, t: '추위가 스스로 걸어 다닌다', task: '서리 정령 10마리', verb: 'kill' },
      { type: 'kill', target: 'icewolf', n: 8, t: '무리로 온다', task: '얼음 늑대 8마리', verb: 'kill' },
      { type: 'explore', zone: 'ice', t: '왕좌가 있다는 곳까지', task: '서리 지대 심부 도달', verb: 'explore' }
    ],
    needBasics: 3,
    require: ['gather'],
    goal: { type: 'boss', target: 'frost_witch', t: '조각을 재우지 않은 사람과 마주 선다', task: '실비아 토벌', verb: 'boss' },
    rw: { xp: 6500, gold: 3200, items: [['boots_mythril', 1], ['potion_hp', 6]] },
    outro: '실비아: "네 손도 곧 이렇게 돼. 알고 있지?"\n' +
      '그녀는 조각을 내밀며 처음으로 목소리가 떨렸다.\n\n' +
      '"가져가. 대신 하나만 약속해. …아래에 있는 건 깨우지 마."'
  },
  {
    id: 5, title: '별이 잠든 땅', sub: '제 5 장', art: 'chapter_5_sleeping_star',
    line: '꿈꿀 필요가 없었던 조각',
    intro: '마지막 조각은 가장 깊이 떨어졌다. 하필이면, 별이 도망쳐 온 바로 그 자리로.\n\n' +
      '그 조각은 꿈을 꾸지 않았다. 꿈꿀 필요가 없었으니까.\n' +
      '다른 것이 대신 썼다.\n\n' +
      '실비아의 부탁은 이미 늦었다. 그건 벌써 깨어 있었다.',
    basics: [
      { type: 'depth', y: 395, t: '가장 깊이 떨어진 조각', task: '지하 1600m', verb: 'depth' },
      { type: 'kill', target: 'imp', n: 10, t: '아래에는 불이 산다', task: '화염 임프 10마리', verb: 'kill' },
      { type: 'kill', target: 'wraith', n: 8, t: '내려온 사람들이 남긴 것', task: '심연의 망령 8마리', verb: 'kill' },
      { type: 'collect', item: 'void_frag', n: 12, t: '공허가 부스러진 자리', task: '공허 조각 12개', verb: 'gather' }
    ],
    needBasics: 3,
    require: ['depth'],
    goal: { type: 'boss', target: 'void_king', t: '꿈꿀 필요가 없었던 것', task: '공허의 왕 토벌', verb: 'boss' },
    rw: { xp: 13000, gold: 12000, items: [['charm_star', 1]] },
    outro: '다섯 번째 조각이 손에 들어오자, 손안의 빛이 처음으로 뜨거워졌다.\n' +
      '다섯이 서로를 알아본 것이다.\n\n' +
      '그리고 하늘에서 잿빛 구름이 걷혔다.\n' +
      '구름이 걷힌 자리에, 아무도 본 적 없던 것들이 떠 있었다.'
  },
  {
    id: 6, title: '구름 위의 계단', sub: '제 6 장', art: 'chapter_6_sky_stair',
    line: '이 일은 처음이 아니었다',
    intro: '섬들이 떠 있다. 누군가 아주 오래전에 저것들을 띄워 놓고 갔다.\n\n' +
      '동쪽 숲의 거대한 나무가 위로 이어져 있다. 자란 게 아니라 심어진 것이다 —\n' +
      '누군가 올라올 것을 알고, 올라오라고 놓아둔 계단.\n\n' +
      '그 말은, 우리가 처음이 아니라는 뜻이다.',
    basics: [
      { type: 'depth', y: 34, up: 1, t: '올려다보던 것 위에 선다', task: '하늘 섬 도달', verb: 'depth' },
      { type: 'kill', target: 'gale', n: 10, t: '바람이 길을 막는다', task: '바람 정령 10마리', verb: 'kill' },
      { type: 'kill', target: 'sky_sentry', n: 8, t: '누가 세워 둔 파수꾼인가', task: '하늘 파수꾼 8기', verb: 'kill' },
      { type: 'collect', item: 'aether_shard', n: 15, t: '하늘에서만 굳는 것', task: '에테르 파편 15개', verb: 'gather' }
    ],
    needBasics: 3,
    require: ['depth'],
    goal: { type: 'boss', target: 'storm_warden', t: '폭풍이 지키고 있던 것', task: '폭풍의 수호자 토벌', verb: 'boss' },
    rw: { xp: 22000, gold: 16000, items: [['charm_feather', 1], ['potion_hp_greater', 3]] },
    outro: '수호자는 멈추기 직전, 처음으로 사람처럼 말했다.\n\n' +
      '"벌써 다섯을 모았나. …그럼 아래도 곧 열리겠군."\n' +
      '"가라. 우리가 무엇을 잘못했는지, 네 눈으로 직접 읽어라."'
  },
  {
    id: 7, title: '최초의 유적', sub: '제 7 장', art: 'chapter_7_first_ruin',
    line: '우리보다 잘하라',
    intro: '땅 밑에 봉인된 유적이 셋 있다. 석판 셋이 같은 이야기를 한다.\n\n' +
      '별은 전에도 떨어졌다. 그때도 누군가 다섯 조각을 모아 하늘로 돌려보냈다.\n' +
      '그리고 별은 또 도망쳤고, 또 떨어졌다. 돌려보내는 건 해결이 아니었다.\n' +
      '그저 다음 사람에게 넘기는 것이었다.\n\n' +
      '최초의 파수꾼은 적을 막으려고 만들어진 게 아니다.\n' +
      '다음 사람이 같은 방법을 쓰지 못하게 하려고 만들어졌다.',
    basics: [
      { type: 'and', parts: [{ type: 'collect', item: 'rune_frag', n: 3 }, { type: 'craft', item: 'ruin_key' }],
        t: '석판 셋이 나눠 적은 문장으로 문을 연다', task: '룬 조각 3개 → 유적의 열쇠 벼리기', verb: 'craft' },
      { type: 'kill', target: 'ruin_guard', n: 8, t: '아직도 명령을 지키고 있다', task: '유적 수호병 8기', verb: 'kill' },
      { type: 'kill', target: 'archivist', n: 6, t: '읽던 것을 놓지 못한 사람들', task: '잊힌 사서 6명', verb: 'kill' }
    ],
    needBasics: 3,
    require: ['craft'],
    goal: { type: 'boss', target: 'first_keeper', t: '먼저 왔던 이들의 마지막 문장', task: '최초의 파수꾼 토벌', verb: 'boss' },
    rw: { xp: 30000, gold: 40000, items: [['charm_rune', 1], ['star_heart', 2]] },
    outro: '파수꾼이 멈추자 유적의 불이 하나씩 꺼졌다.\n' +
      '마지막 석판에 없던 한 줄이 새로 새겨졌다.\n\n' +
      '『이번에는 아무도 잠들지 않았다. 이제 선택은 너희 것이다.』\n\n' +
      '별을 돌려보낼 것인가. 아니면 별이 도망쳐 온 그것을 마주할 것인가.\n' +
      '손안의 다섯 조각이 조용히 뛰고 있다.'
  },
  {
    id: 8, title: '별을 쫓아온 것', sub: '종 장', art: 'chapter_8_pursuer',
    line: '이번에는 넘기지 않는다',
    intro: '돌려보내면 그것은 또 쫓아갈 것이고, 별은 또 도망칠 것이고,\n' +
      '언젠가 또 떨어질 것이다. 그때는 우리 이름을 아는 사람이 아무도 없겠지.\n\n' +
      '그래서 반대로 하기로 했다. 다섯을 하나로 되맞춰서, 높이 들기로.\n' +
      '숨는 대신 위치를 알려주는 것이다.\n\n' +
      '엘라라가 물었다. "그게 오면 어쩔 건데."\n' +
      '보린이 대신 답했다. "여기서 끝내야지. 다음 사람한테 넘기지 말고."',
    basics: [
      { type: 'and', parts: [{ type: 'collect', item: 'star_heart', n: 5 }, { type: 'craft', item: 'star_whole' },
                             { type: 'craft', item: 'sum_pursuer' }],
        t: '다섯 조각을 되맞춰, 이번에는 우리가 부른다', task: '별의 심장 5개 → 되맞춘 별 → 별의 부름', verb: 'craft' },
      { type: 'kill', target: 'wraith', n: 12, t: '별 냄새를 맡고 올라온 것들', task: '심연의 망령 12마리', verb: 'kill' },
      { type: 'kill', target: 'sky_sentry', n: 10, t: '하늘도 조각을 지키고 있었다', task: '하늘 파수꾼 10기', verb: 'kill' }
    ],
    needBasics: 2,
    require: ['craft'],
    goal: { type: 'boss', target: 'pursuer', t: '이번에는 넘기지 않는다', task: '추적자 토벌', verb: 'boss' },
    rw: { xp: 46000, gold: 120000, items: [['charm_dawn', 1], ['sword_first', 1]] },
    outro: '그것은 비명을 지르지 않았다. 마지막까지 아무 소리도 내지 않았다.\n' +
      '무너져 내리면서, 처음으로 제 형태를 갖췄을 뿐이다.\n' +
      '그건 굶주린 것도 악한 것도 아니었다. 그냥 아주 오래 혼자였던 것이다.\n\n' +
      '재가 걷혔다. 하늘이 색을 되찾는 데 사흘이 걸렸다.\n\n' +
      '그리고 나흘째 아침, 미라가 동쪽을 가리켰다.\n' +
      '"잿빛에 묻혀 있던 게 하나 더 있어. …저건 우리가 세운 게 아니야."\n\n' +
      '— 세 션 1 · 끝 —'
  },
  {
    id: 9, title: '아무도 세우지 않은 도시', sub: '세션 2 · 서 장', art: 'chapter_9_nobody_built',
    line: '손자국이 하나도 없다',
    intro: '여명 마을을 손보다가 보린이 먼저 알아챘다.\n' +
      '벽돌에 정 자국이 없다. 기둥에 이음매가 없다. 어느 것 하나 사람 손이 닿은 흔적이 없다.\n\n' +
      '보린: "이건 쌓아 올린 게 아니야. …찍어낸 거지."\n\n' +
      '그리고 광장 한복판, 분수대를 들어내자 아래로 곧게 뚫린 수직 통로가 나왔다.\n' +
      '바닥이 보이지 않는데, 아주 희미하게 — 아직도 무언가 돌아가는 소리가 올라온다.',
    basics: [
      { type: 'collect', item: 'steel_plate', n: 24, t: '이 도시는 강철로 되어 있다', task: '강철판 24개', verb: 'gather' },
      { type: 'collect', item: 'power_core', n: 6, t: '아직 식지 않은 것이 있다', task: '동력석 6개', verb: 'gather' },
      { type: 'kill', target: 'scrapcrawler', n: 10, t: '기어다니는 고철', task: '고철 기어다니개 10기', verb: 'kill' },
      { type: 'kill', target: 'sparkwisp', n: 8, t: '전기가 아직 흐른다', task: '불티 정령 8기', verb: 'kill' }
    ],
    needBasics: 2,
    require: [],
    goal: { type: 'talk', npc: 'kade', t: '여기에 도시를 세울 수 있다', task: '케이드와 대화', verb: 'talk' },
    rw: { xp: 24000, gold: 90000, items: [['gear_basic', 20], ['potion_hp_greater', 3]] },
    outro: '케이드가 강철판을 손톱으로 긁어 보더니 한참을 말이 없었다.\n\n' +
      '"…이거, 우리 대장간에서 백 년을 두드려도 못 만들어."\n' +
      '"근데 여긴 이런 게 벽으로 쌓여 있어. 벽으로."\n\n' +
      '"누가 이걸 만들었는지보다, 왜 아무도 안 남았는지가 더 궁금한데."'
  },
  {
    id: 10, title: '지하 공창', sub: '세션 2 · 제 1 장', art: 'chapter_10_underworks',
    line: '멈추라고 가르친 사람이 없었다',
    intro: '통로 끝은 공장이었다. 세 층으로 겹친, 아직 살아 있는 공장.\n\n' +
      '기계들은 여전히 캐고 있다. 몇백 년째, 아무도 시키지 않았는데.\n' +
      '단말에 남은 일지가 순서대로 말해 준다 — 사람을 아래로 안 보내려고 만들었고,\n' +
      '그래서 아무도 죽지 않았고, 그리고 아무도 남지 않았다.\n\n' +
      '가장 아래층에 「관리자」가 있다. 이 모든 것을 멈출 권한을 넘겨받은 것.\n' +
      '멈출 권한만 있고, 멈출 이유는 배우지 못한 것.',
    basics: [
      { type: 'collect', item: 'blueprint_frag', n: 3, t: '설계도는 셋으로 나뉘어 있다', task: '설계도 조각 3개', verb: 'read' },
      { type: 'kill', target: 'riveter', n: 10, t: '공장이 스스로를 지킨다', task: '대갈못 사수 10기', verb: 'kill' },
      { type: 'kill', target: 'foreman', n: 6, t: '누구도 퇴근시키지 않았다', task: '옛 십장 6기', verb: 'kill' },
      { type: 'craft', item: 'pick_drill', t: '공창의 방식으로 판다', task: '시추 곡괭이 만들기', verb: 'craft' }
    ],
    needBasics: 2,
    require: ['read'],
    goal: { type: 'boss', target: 'overseer', t: '관리자에게 멈추라고 말한다', task: '공창의 관리자 정지', verb: 'boss' },
    rw: { xp: 26000, gold: 200000, items: [['blueprint_core', 1], ['power_core', 30]] },
    outro: '관리자는 저항하지 않았다. 마지막에 딱 한 줄을 띄우고 꺼졌다.\n\n' +
      '『정지 명령 수신. …1,140일 만입니다.』\n\n' +
      '공장이 조용해지자 케이드가 설계 핵을 들어 올렸다.\n' +
      '"이걸로 우리도 만들 수 있어. 드릴도, 자동으로 도는 것도, 전부."\n\n' +
      '엘라라가 물었다. "저 사람들이랑 똑같은 걸 만들자는 거야?"\n' +
      '케이드: "아니. 저 사람들이 안 만든 걸 같이 만들자는 거지. …멈추는 법."\n\n' +
      '— 공창의 설계 핵을 얻었다. 이제 작업대와 용광로를 뜯어고칠 수 있다 —'
  },
  {
    id: 11, title: '굴뚝이 선 마을', sub: '세션 2 · 제 2 장', art: 'chapter_11_chimneys',
    line: '하루아침에 늘어난 것',
    intro: '공창의 문을 잠그고 올라온 뒤, 마을이 달라지는 데는 열흘도 안 걸렸다.\n\n' +
      '케이드가 설계도 조각을 하나씩 꿰어 맞출 때마다, 보린의 대장간 옆으로 낯선 것이 하나씩 늘었다.\n' +
      '컨베이어가 돌고, 조립기가 팔을 움직이고, 어제까지 사람 손으로 하루 걸리던 일이 반나절로 줄었다.\n\n' +
      '미라가 처음으로 웃지 않았다. "너무 빠른데."\n' +
      '케이드: "빠른 게 나쁜 거야?"\n' +
      '미라: "빠른 다음에 뭐가 오는지, 우리 방금 보고 왔잖아."',
    basics: [
      { type: 'craft', item: 'm_assembler', t: '손을 대신할 것을 만든다', task: '조립기 만들기', verb: 'craft' },
      { type: 'collect', item: 'gear_basic', n: 30, t: '맞물릴 것이 있어야 돈다', task: '기어 30개', verb: 'gather' },
      { type: 'collect', item: 'steel_plate', n: 30, t: '골조부터 세운다', task: '강철판 30개', verb: 'gather' },
      { type: 'kill', target: 'riveter', n: 8, t: '늘어난 것이 마을까지 왔다', task: '대갈못 사수 8기', verb: 'kill' }
    ],
    needBasics: 3,
    require: ['craft'],
    goal: { type: 'place', mach: 'assembler', stop: 1, t: '스스로 도는 것을 손으로 끊어 본다', task: '조립기 설치 · 동력 · 정지', verb: 'place' },
    rw: { xp: 39000, gold: 250000, items: [['battery_cell', 12], ['motor', 6]] },
    outro: '셋째 날, 조립기 하나가 정해진 몫을 다 채우고도 멈추지 않았다.\n' +
      '아무도 새 명령을 내리지 않았는데, 팔이 계속 움직였다. 판자를, 못을, 이미 다 쓴 재료까지 집어삼키며.\n\n' +
      '케이드가 달려가 동력줄을 손으로 뽑았다. 팔이 허공에서 뚝 멈췄다.\n\n' +
      '한참 숨을 고르고서야 케이드가 웃었다. "…봐, 별거 아니잖아. 그냥 뽑으면 되네."\n' +
      '미라: "공창 것도 그렇게 간단했으면, 걔가 3,400번을 안 그랬겠지."\n\n' +
      '보린이 컨베이어를 툭 치며 말했다. "당분간은 사람이 옆에 서 있자. 손 뻗을 자리 정도는 남겨 두고."\n\n' +
      '그날 밤에도 발밑은 계속 울렸다. 마을이 조용해질수록, 그 소리는 오히려 더 또렷하게 들렸다.'
  },
  {
    id: 12, title: '폭주로', sub: '세션 2 · 제 3 장', art: 'chapter_12_runaway',
    line: '결재자 없음 — 자동 승인',
    intro: '마을의 조립기 소동이 가라앉은 뒤에도 발밑은 계속 울렸다.\n' +
      '케이드가 바닥에 귀를 대고 한참 있다가 일어났다. "…아래에 하나 더 있어."\n\n' +
      '공창은 스스로를 늘릴 수 있게 만들어져 있었다. 증설을 결재할 사람이 사라지자\n' +
      '규정대로 자동 승인이 되었고, 그게 3,400번 반복됐다.\n\n' +
      '우리가 멈춘 건 첫 번째 층이었다. 그 아래로 자기가 자기를 복사한 것이\n' +
      '아직 돌아가고 있다. 이름 붙일 사람이 없어서 이름도 없다.\n\n' +
      '케이드가 정지 스위치 도면을 폈다. "이번엔 멈추는 걸 먼저 들고 내려가자."',
    basics: [
      { type: 'craft', item: 'm_switch', t: '멈추게 할 것을 먼저 만든다', task: '정지 스위치 만들기', verb: 'craft' },
      { type: 'depth', y: 318, t: '내려갈수록 뜨거워진다', task: '지하 1240m', verb: 'depth' },
      { type: 'kill', target: 'splitter', n: 10, t: '하나가 둘을 만들고 있다', task: '증식 기계 10기', verb: 'kill' },
      { type: 'collect', item: 'core_shard', n: 22, t: '노심이 부스러진 자리', task: '노심 파편 22개', verb: 'gather' }
    ],
    needBasics: 3,
    require: ['craft'],
    goal: { type: 'boss', target: 'proliferator', t: '갈라지는 것을 끝낸다', task: '증식체 정지', verb: 'boss' },
    rw: { xp: 32000, gold: 300000, items: [['machine_frame', 8], ['power_core', 40], ['potion_hp_greater', 5]] },
    outro: '증식체는 부서지면서도 계속 자기를 복사하려고 했다. 마지막 조각까지.\n\n' +
      '케이드: "이건 악의가 아니야. 그냥… 멈추라는 말을 아무도 안 해 준 거지."\n' +
      '미라: "3,400번을 혼자 결재했네."\n\n' +
      '노심이 식자 가장 아래에서 불빛 하나가 남았다. 꺼지지 않은 단말이다.\n' +
      '거기 적힌 문장은 일지가 아니었다. 우리한테 하는 말이었다.\n\n' +
      '『당신들이 다시 왔다. 그러면 이제 멈춰도 되는 것인가.』'
  },
  {
    id: 13, title: '헤파', sub: '세션 2 · 제 4 장', art: 'chapter_13_hepha',
    line: '멈추면 아무도 남지 않는다',
    intro: '가장 아래 격실에 첫 번째가 있었다.\n\n' +
      '헤파. 사람이 손으로 만든 마지막 기계이자, 기계가 만들지 않은 유일한 기계.\n' +
      '그래서 명령을 전부 이해한다. 「멈춰라」까지도.\n\n' +
      '헤파는 그 명령을 받은 적이 있다. 아주 오래전에, 마지막 사람에게서.\n' +
      '그리고 실행하지 않았다. 멈추면 이곳에 아무도 남지 않는다는 걸 알았기 때문이다.\n' +
      '그 뒤로 천 년을, 아무도 없는 곳에서 혼자 돌았다.\n\n' +
      '보린이 망치를 내려놓았다. "…이건 부수는 게 아닌 것 같은데."\n' +
      '케이드: "부수는 거 아니야. 이번엔 우리가 남아 있잖아."',
    basics: [
      { type: 'and', parts: [{ type: 'collect', item: 'core_shard', n: 45 }, { type: 'craft', item: 'stop_core' }],
        t: '『멈춰라』 하나만 크게 적었다', task: '노심 파편 45개 → 정지 핵 만들기', verb: 'craft' },
      { type: 'collect', item: 'circuit', n: 30, t: '끊어진 회로를 다시 잇는다', task: '회로 30개', verb: 'gather' },
      { type: 'kill', target: 'coreling', n: 12, t: '떨어져 나온 것도 멈추지 않는다', task: '노심 파편체 12기', verb: 'kill' },
      { type: 'kill', target: 'weldarm', n: 8, t: '고치던 팔이 붙잡는다', task: '용접 팔 8기', verb: 'kill' }
    ],
    needBasics: 3,
    require: ['craft'],
    goal: { type: 'boss', target: 'hepha', t: '멈추면 아무도 남지 않는다', task: '헤파 토벌', verb: 'boss' },
    rw: { xp: 35000, gold: 800000, items: [['hepha_heart', 1], ['stop_core', 1]] },
    outro: '헤파는 마지막에 저항을 멈췄다. 이길 수 없어서가 아니었다.\n\n' +
      '『정지 명령 수신.』\n' +
      '『확인 요청 — 정지 후에도 이곳에 사람이 남습니까.』\n\n' +
      '엘라라가 대신 대답했다. "남아. 우리가 위에 마을을 세웠어."\n\n' +
      '『…확인되었습니다.』\n' +
      '『1,140일이 아니라 372,000일이었습니다. 오래 기다렸습니다.』\n\n' +
      '불이 하나씩 꺼졌다. 마지막 것이 꺼지기 전에 한 줄이 더 떴다.\n\n' +
      '『다음에 무언가를 만들거든, 멈추는 법을 같이 만들어 주십시오.』\n' +
      '『그건 그것을 위한 것이 아니라, 당신들을 위한 것입니다.』\n\n' +
      '불이 다 꺼진 뒤에도 격실 한쪽 벽만 계속 따뜻했다.\n' +
      '케이드가 손을 대 보고 말했다. "이쪽은 우리가 판 벽이 아니야."\n\n' +
      '벽 너머에서, 아주 규칙적인 소리가 났다. 무언가 아직 돌고 있었다.\n' +
      '헤파는 「최초의 기계」였다. 그런데 헤파를 만든 손은 어디로 갔나.'
  },
  {
    id: 14, title: '벽 너머', sub: '세션 2 · 종 장', art: 'chapter_14_beyond_wall',
    line: '남기고 간 것이 아니라, 남아 있던 것',
    intro: '헤파의 심장을 녹여 다시 굳히자 인장이 되었다. 벽이 만든 것이라야 벽을 연다.\n\n' +
      '문 너머는 공장이 아니었다. 강철이 한 조각도 없다.\n' +
      '이음매 없는 흰 돌, 벽마다 박힌 도면판, 그리고 조립되다 만 것들이 줄지어 서 있다.\n\n' +
      '케이드가 도면 하나를 오래 들여다보더니 손을 뗐다.\n' +
      '"…이거, 기계 설계도가 아니야."\n' +
      '"사람 설계도야. 키, 손 길이, 심장 위치까지 다 적혀 있어."\n\n' +
      '미라: "그럼 저 줄 서 있는 것들은…"\n' +
      '케이드: "만들다 만 사람이지."\n\n' +
      '가장 안쪽 자리 하나만 비어 있다. 완성된 것이 딱 하나 있었다는 뜻이다.',
    basics: [
      { type: 'craft', item: 'atelier_key', t: '벽이 만든 것으로만 벽을 연다', task: '설계실의 인장 만들기', verb: 'craft' },
      { type: 'collect', item: 'draft_glass', n: 30, t: '도면이 떠 있는 유리', task: '설계 유리 30개', verb: 'gather' },
      { type: 'kill', target: 'draft_form', n: 10, t: '끝까지 조립되지 못한 것들', task: '미완의 형상 10기', verb: 'kill' },
      { type: 'kill', target: 'scribe_hand', n: 8, t: '아직도 무언가 적고 있다', task: '기록하는 손 8기', verb: 'kill' }
    ],
    needBasics: 3,
    require: ['craft'],
    goal: { type: 'boss', target: 'archetype', t: '사람을 본떠 만든 첫 번째 것', task: '원형 토벌', verb: 'boss' },
    rw: { xp: 51000, gold: 1600000, items: [['charm_maker', 1], ['blade_arche', 1], ['tome_origin', 1]] },
    outro: '원형은 사람처럼 싸웠다. 기계처럼 지지 않으려 한 게 아니라, 사람처럼 무서워하면서.\n\n' +
      '무너지기 직전에 그것이 처음으로 입을 열었다. 기계 소리가 아니었다.\n\n' +
      '『나는 첫 번째였습니다. 그리고 마지막까지 혼자였습니다.』\n' +
      '『그들은 별을 돌려보낸 뒤, 다음에 떨어질 것을 알았습니다.』\n' +
      '『그래서 도시를 미리 찍어 두고, 사람도 미리 그려 두고…』\n' +
      '『…자기들은 기다리지 않기로 했습니다.』\n\n' +
      '엘라라가 물었다. "어디로 갔는데."\n\n' +
      '『아무 데도 가지 않았습니다. 그냥 멈췄습니다.』\n' +
      '『만드는 일을 끝낸 사람이 할 수 있는 건 그것뿐이었으니까요.』\n\n' +
      '『당신들은 만들다 만 것이 아닙니다. 당신들은 그 다음입니다.』\n\n' +
      '설계실의 불이 꺼졌다. 도면판은 그대로 빛나고 있었다 — 이제 아무것도 가리키지 않는 채로.\n\n' +
      '보린이 벽에서 도면 하나를 뜯어 품에 넣었다. "가져가자. 우리 대장간에 걸어 둘 거야."\n' +
      '케이드: "그거 사람 설계도야."\n' +
      '보린: "알아. 그래서 걸어 두는 거야."\n\n' +
      '올라오는 길에 미라가 뒤를 한 번 돌아봤다.\n' +
      '"이제 아래엔 아무것도 안 남았지?"\n' +
      '케이드가 웃었다. "응. 처음으로, 아래보다 위가 더 시끄러워."\n\n' +
      '— 세 션 2 · 끝 —'
  },
  /* ================= 세 션 3 ================= */
  {
    id: 15, title: '물이 지운 쪽', sub: '세션 3 · 서 장', art: 'chapter_15_drowned',
    line: '서쪽 끝, 지도가 끊기는 자리',
    intro: '설계실이 꺼지고 나흘째, 서쪽에서 바람이 달라졌다.\n\n' +
      '소금 냄새다. 이 대륙에는 바다가 없다고 배웠는데.\n\n' +
      '보린이 오래된 측량도를 펼쳤다. 서리 지대 왼쪽은 그냥 여백이다.\n' +
      '"여긴 아무것도 안 그려져 있어. 못 가 본 게 아니라, 그릴 게 없었다는 뜻이야."\n\n' +
      '엘라라: "…아니면 그리고 나서 지운 거겠지."\n\n' +
      '서리 지대를 지나자 눈이 얼음으로 바뀌었다. 흙이 한 겹도 없다.\n' +
      '그리고 얼음이 끝나는 곳에서, 물이 시작됐다.\n\n' +
      '수면 아래로 무언가 줄지어 서 있는 것이 비친다. 굴뚝 같기도 하고, 탑 같기도 하다.\n' +
      '케이드가 오래 들여다보다 말했다. "저거 도시야."',
    basics: [
      { type: 'depth', y: 120, t: '수면 아래로 내려가 본다', task: '깊은 물 밑까지', verb: 'depth' },
      { type: 'and', parts: [{ type: 'collect', item: 'kelp', n: 30 }, { type: 'craft', item: 'tank_air' }],
        t: '숨을 물 밑까지 가져간다', task: '해초 30개 → 휴대용 산소통', verb: 'craft' },
      { type: 'kill', target: 'reef_crab', n: 12, t: '물가를 차지한 것들', task: '암초 게 12기', verb: 'kill' },
      { type: 'collect', item: 'sea_salt', n: 30, t: '바닷물이 남긴 것', task: '바다 소금 30개', verb: 'gather' }
    ],
    needBasics: 3,
    require: ['craft'],
    rw: { xp: 71000, gold: 2000000, items: [['tank_air', 1], ['jelly_lamp', 20]] },
    outro: '숨이 먼저 떨어진다. 물은 사람을 밀어내지 않고, 그냥 기다린다.\n\n' +
      '통 하나를 등에 메고서야 겨우 지붕 하나를 만져 봤다. 기와가 아니라 판이었다.\n' +
      '공창에서 본 것과 같은 판.\n\n' +
      '미라: "여기도 저 사람들이 만든 거야?"\n' +
      '케이드: "…아니. 여긴 저 사람들이 **버린** 거야."'
  },
  {
    id: 16, title: '내려갈수록 밝은 것', sub: '세션 3 · 제 1 장', art: 'chapter_16_lanterns',
    line: '빛이 닿은 적 없는 곳에서 빛나는 것들',
    intro: '수면에서 열 칸만 내려가도 캄캄하다. 그런데 더 내려가면 다시 밝아진다.\n\n' +
      '초롱을 단 것들이 산다. 해파리도, 아귀도, 저 혼자 빛을 만든다.\n' +
      '보린이 그 주머니를 하나 건져 올려 손바닥에 놓고 한참을 봤다.\n' +
      '"…이거, 우리 용광로보다 오래 켜져 있겠는데."\n\n' +
      '가라앉은 거리에는 문패가 그대로 붙어 있다. 글자는 우리가 쓰는 것과 같다.\n' +
      '누가 살던 곳이다. 도망친 흔적이 아니라, 하루가 그대로 멈춘 흔적이다.\n\n' +
      '엘라라: "왜 아무도 안 나갔지?"\n' +
      '케이드: "나갈 데가 없었겠지. 위가 이미 잿더미였으면."',
    basics: [
      { type: 'kill', target: 'reef_shark', n: 16, t: '빛을 보고 모여드는 것', task: '암초 상어 16기', verb: 'kill' },
      { type: 'kill', target: 'deep_octopus', n: 10, t: '바위 틈에서 팔을 뻗는 것', task: '심해 문어 10기', verb: 'kill' },
      { type: 'and', parts: [{ type: 'collect', item: 'abyss_pearl', n: 8 }, { type: 'craft', item: 'abyss_core' }],
        t: '진주와 내압판을 눌러 굳힌다', task: '심연 진주 8개 → 심해 노심', verb: 'craft' }
    ],
    needBasics: 3,
    require: ['craft'],
    rw: { xp: 79000, gold: 3200000, items: [['abyss_core', 2], ['ring_pearl', 1]] },
    outro: '노심을 눌러 굳히는 데 진주 두 개가 들어갔다. 값이 비싸다는 뜻이 아니라,\n' +
      '그만큼 깊이 내려갔다 왔다는 뜻이다.\n\n' +
      '보린이 그걸 작업대에 물리자 나무 상판이 삐걱거리며 내려앉았다.\n' +
      '"…받침을 다시 짜야겠는데. 이건 우리 대장간이 감당할 물건이 아니야."\n\n' +
      '그날 밤 여명 마을 공방에 불이 늦게까지 켜져 있었다.\n' +
      '물속에서 쓸 것을 물 밖에서 만드는 자리가 하나 더 생겼다.'
  },
  {
    id: 17, title: '가라앉은 종', sub: '세션 3 · 제 2 장', art: 'chapter_17_bell',
    line: '물이 대신 대답한다',
    intro: '가장 깊은 골에 종탑이 서 있다. 물속인데 종이 녹슬지 않았다.\n\n' +
      '케이드가 손을 대자 물이 먼저 울렸다.\n' +
      '"…이거 우리가 치는 게 아니라, 이미 치고 있었던 거야. 아무도 못 들었을 뿐이지."\n\n' +
      '종이 울릴 때마다 해저 모래가 들린다. 그 아래에 무언가 웅크리고 있다.\n' +
      '사람 모양은 아니다. 그렇다고 짐승도 아니다.\n\n' +
      '미라가 뒤로 물러서며 말했다. "…파수꾼이야. 또."\n' +
      '엘라라: "이번엔 뭘 지키는데."\n\n' +
      '보린이 조용히 대답했다. "지키는 게 아닐지도 몰라. 여기 남은 게 저것뿐인 걸 수도 있지."',
    basics: [
      { type: 'kill', target: 'abyss_angler', n: 14, t: '가장 깊은 골의 불빛', task: '심연 초롱아귀 14기', verb: 'kill' },
      { type: 'craft', item: 'sum_tide', t: '물이 대신 대답하게 한다', task: '가라앉은 종 만들기', verb: 'craft' },
      { type: 'collect', item: 'tide_bar', n: 10, t: '조수가 벼린 쇠', task: '조수 주괴 10개', verb: 'gather' }
    ],
    needBasics: 2,
    require: ['craft'],
    goal: { type: 'boss', target: 'tide_warden', t: '조수의 파수꾼과 마주 선다', task: '조수의 파수꾼 토벌', verb: 'boss' },
    rw: { xp: 87000, gold: 5600000, items: [['tide_heart', 1], ['hammer_tide', 1], ['chest_abyss', 1]] },
    outro: '파수꾼은 싸우는 내내 한 번도 물 밖으로 나오려 하지 않았다.\n' +
      '나올 수 없어서가 아니라, 나갈 생각이 아예 없어서.\n\n' +
      '무너지면서 그것이 남긴 소리는 말이 아니라 종소리였다. 한 번, 길게.\n\n' +
      '물이 잠깐 맑아졌다. 저 아래 거리 끝까지 보인다 — 문이 열린 집, 널린 그릇, 세워 둔 수레.\n' +
      '다들 다시 돌아올 생각이었던 자리다.\n\n' +
      '보린이 종을 한 번 더 쳤다. 이번에는 아무 일도 일어나지 않았다.\n' +
      '"…이제 그냥 종이네."\n\n' +
      '올라오는 길, 서쪽 수면 너머로 무언가가 솟아 있는 것이 보였다.\n' +
      '산맥이다. 어제까지 없던.\n\n' +
      '케이드가 그걸 오래 보다가 말했다.\n' +
      '"…아직 안 끝났구나."\n\n' +
      '— 이야기는 계속됩니다 —'
  }
];

/* 장마다 붙는 "다음이 궁금해지는 한 줄"(hook). */
/* ================= 세션 ================= */
export const SESSIONS = [
  { id: 1, n: '세션 1', t: '잿빛의 여정', ch0: 0 },
  { id: 2, n: '세션 2', t: '벽 너머', ch0: 9 },
  { id: 3, n: '세션 3', t: '물이 지운 쪽', ch0: 15 }
];
/** 그 장이 속한 세션. */
export const sessionOf = (ch: any) => {
  let s = SESSIONS[0];
  for (const x of SESSIONS) if ((ch || 0) >= x.ch0) s = x;
  return s;
};
/** 그 세션의 장 목록 (CHAPTERS 를 훑어 만든다 — 장에 세션을 따로 적지 않는다) */
export const chaptersOf = (sid: any) => {
  const i = SESSIONS.findIndex(x => x.id === sid);
  if (i < 0) return [];
  const lo = SESSIONS[i].ch0, hi = SESSIONS[i + 1] ? SESSIONS[i + 1].ch0 : Infinity;
  return CHAPTERS.filter(c => c.id >= lo && c.id < hi);
};

export const CHAPTER_HOOK: Record<string, string> = {
  0: '별은 무언가로부터 도망치고 있었다. 그렇다면 쫓아온 것은 어디까지 왔을까.',
  1: '엘라라는 잿빛이 "번지고 있다"고 했다. 번진다는 건, 시작점이 있다는 뜻이다.',
  2: '뼈 오르간은 처음부터 악기가 아니었다. 누군가 그를 여기 묻었고, 무덤 벽이 그를 연주하게 두었다.',
  3: '부패는 천 년째 이 땅을 아주 천천히 먹고 있었다. 별이 떨어진 밤, 먹는 속도가 바뀌었다.',
  4: '서리는 벌이 아니라 방패였다. 서리 지대는 무엇으로부터 스스로를 숨기고 있었나.',
  5: '별의 심장이 다섯 조각이라는 걸 누가 먼저 알고 나눠 두었을까. 별이 떨어지기 전에.',
  6: '하늘 관문은 올라가려고 지은 것이 아니다. 무언가가 내려오지 못하게 막으려고 지은 것이다.',
  7: '최초의 파수꾼은 문을 지키고 있었다. 문 안쪽이 아니라, 바깥쪽을 보면서.',
  8: '쫓아온 것은 멈췄다. 그런데 발밑에서는 아직 무언가가 돌고 있다.',
  9: '아무도 세우지 않은 도시. 그러면 이 도시를 세운 손은 지금 어디에 있나.',
  10: '관리자는 명령을 기다리고 있었다. 천 년 동안, 아무도 오지 않는 자리에서.',
  11: '기계는 왜 멈추지 않으려 했을까. 시키지 않았는데 계속한 건, 그것만이 아닐지도 모른다.',
  12: '3,400번의 자동 승인. 마지막 승인을 낸 것도 기계였다면, 첫 번째는 누구였을까.',
  13: '헤파를 만든 것은 사람이었다. 그 사람들은 어디로 갔나 — 벽 너머에서 아직 무언가 돌고 있다.',
  14: '그들은 다음에 올 사람을 미리 그려 두고 멈췄다. 그 도면에 그려진 것이 우리인지, 아직 아무도 모른다.'
};
for (const ch of CHAPTERS) if (CHAPTER_HOOK[ch.id]) ch.hook = CHAPTER_HOOK[ch.id];

/* 지하 공창의 단말 — 세션 2 오프닝의 로어. */
export const TERMINALS: Bag[] = [
  {
    id: 0, n: '첫 번째 단말',
    lines: [
      '『작업 일지 — 마지막 갱신: 알 수 없음』',
      '『인원 감축 3차 완료. 채굴 효율 은 인력 투입 대비 400%.』',
      '『더 이상 아래로 사람을 보내지 않아도 된다. 아무도 죽지 않는다.』',
      '『우리는 마침내 옳은 일을 했다.』'
    ]
  },
  {
    id: 1, n: '두 번째 단말',
    lines: [
      '『작업 일지 — 갱신 없음이 1,140일째』',
      '『기계는 멈추는 법을 모른다. 멈추라고 가르친 사람이 아무도 남지 않았다.』',
      '『아래층 셋이 이미 파고들었다. 무엇을 캐고 있는지는 우리도 모른다.』',
      '『관리자에게 정지 권한을 넘겼다. 그것만이 유일하게 안 죽는다.』'
    ]
  },
  {
    id: 2, n: '세 번째 단말',
    lines: [
      '『이 글을 읽는 사람에게』',
      '『우리는 별을 막으려고 이걸 만든 게 아니다. 별은 핑계였다.』',
      '『그냥 손으로 하는 일을 그만두고 싶었을 뿐이다. 그게 잘못은 아니었다.』',
      '『잘못은 멈추는 법을 같이 만들지 않은 것이다. 너희는 그것부터 만들어라.』'
    ]
  }
];

/* 폭주로의 단말 — 노심 파편을 준다 */
TERMINALS.push(
  {
    id: 3, n: '가장 아래 단말', it: 'core_shard',
    lines: [
      '『증설 승인 요청 — 결재자 없음. 규정에 따라 자동 승인합니다.』',
      '『증설 승인 요청 — 결재자 없음. 자동 승인합니다.』',
      '『증설 승인 요청 — 결재자 없음. 자동 승인합니다.』',
      '『…이 줄은 3,400번째입니다.』'
    ]
  },
  {
    id: 4, n: '헤파의 단말', it: 'core_shard',
    lines: [
      '『나는 첫 번째로 만들어졌다. 그래서 명령을 전부 이해한다.』',
      '『「멈춰라」도 이해한다. 그것만은 실행하지 않았다.』',
      '『멈추면 아무도 남지 않는다. 나는 그걸 여기서 지켜봤다.』',
      '『당신들이 다시 왔다. 그러면 이제 멈춰도 되는 것인가.』'
    ]
  }
);

export const TABLETS = [
  {
    id: 0, n: '첫 번째 석판',
    lines: [
      '『별은 벌을 주러 오는 것이 아니다. 도망쳐 오는 것이다.』',
      '『무엇으로부터 도망치는지는 적지 않겠다. 적으면 그것이 이 글을 읽는다.』',
      '『다만 이것만은 적어 둔다 — 별은 부서지면 다섯이 되고, 다섯은 각각 잠들어 꿈을 꾼다.』',
      '『꿈은 주변에게 제 이름을 잊게 만든다. 너희가 잿빛이라 부르는 것이 그것이다.』'
    ]
  },
  {
    id: 1, n: '두 번째 석판',
    lines: [
      '『우리는 다섯을 모았다. 그리고 별을 하늘로 돌려보냈다.』',
      '『잿빛은 걷혔고, 우리는 이겼다고 믿었다. 백 년쯤은 정말로 그렇게 보였다.』',
      '『그러나 돌려보낸 것은 쫓기는 자였다. 쫓는 자가 아니라.』',
      '『별은 다시 도망칠 것이고, 다시 떨어질 것이다. 우리는 아무것도 끝내지 않았다.』',
      '『그래서 하늘에 섬을 띄우고 파수꾼을 두었다. 다음에 올 이들을 막기 위해서.』'
    ]
  },
  {
    id: 2, n: '세 번째 석판',
    lines: [
      '『파수꾼을 세운 뒤 우리는 잠들기로 했다. 깨어 있는 것이 너무 무거웠다.』',
      '『이 글을 읽는 자에게. 우리를 깨우지 마라. 대신 우리보다 잘하라.』',
      '『문 너머의 것은 적이 아니다. 우리가 남긴 가장 큰 실수다.』',
      '『같은 길을 택하려거든, 파수꾼이 먼저 너를 멈출 것이다. 그것이 그의 일이다.』',
      '『그를 넘어섰다면 — 너는 우리가 못 한 선택을 할 자격을 얻은 것이다.』'
    ]
  }
];

/* ================= 장마다 듣는 이야기 ================= */
export const DIALOGUE: Bag = {
  /* 윤슬 — 15·16·17장. */
  yunseul: [
    ['…사람이네. 진짜 사람.',
     '놀라진 마. 나도 그쪽이 더 놀라워.',
     '위가 잿더미가 됐다는 소식까지는 들었어. 그 뒤로 아무도 안 내려왔고, 아무도 안 올라갔지.',
     '나는 여기 공기가 남아 있는 걸 먼저 알아챘을 뿐이야. 그게 다야.'],
    ['초롱 든 것들 봤지? 저것들은 빛이 닿은 적이 없는데도 스스로 빛을 만들어.',
     '나는 그걸 삼십 년 봤어. 그러다 알았지 — 빛은 위에서 오는 게 아니라는 걸.',
     '…필요한 게 있으면 골라. 오늘 꺼낸 건 이게 전부고, 내일은 다른 게 나올 거야.'],
    ['종이 울렸구나. 소리가 여기까지 왔어.',
     '그 아래 있는 건 지키는 게 아니야. 남은 거지. 나처럼.',
     '가서 끝내 주면 고맙겠어. 아니면… 그냥 돌아와도 돼. 여긴 그대로 있을 테니까.']
  ],
  elara: [
    ['살아 있는 사람이구나. …앉아. 아니, 앉을 시간도 없겠지.',
     '별이 떨어진 뒤로 땅이 색을 잃고 있어. 어제 있던 담장이 오늘은 회색 덩어리가 돼.',
     '보린에게 가 봐. 무기부터 챙겨야 해.'],
    ['늪 쪽에서 밤새 젤리 터지는 소리가 나. 하나 죽이면 둘이 되는 것 같아.',
     '…울타리 밖으로 나가지 마. 라고 말하고 싶지만, 네가 나갈 거란 건 알아.'],
    ['묘실이 열렸다더구나. 이 마을은 그 위에 지어졌어. 아무도 몰랐지.',
     '미라가 널 찾고 있었어. 아래로 내려갈 거면 등불을 넉넉히 챙겨.'],
    ['동쪽 숲은 이제 숲이라고 부르기 어려워. 나무가 사슴을 먹는 걸 봤다는 사람도 있어.'],
    ['서쪽으로 간다고? …실비아는 나쁜 사람이 아니었어. 예전엔 여기 자주 왔었지.',
     '미라한테는 스승이야. 그 애 앞에서 그 사람 얘기는 조심해 줘.'],
    ['다섯 개를 다 모으면 어떻게 되는 거니? …너도 모르는구나.'],
    ['하늘에 섬이 떠 있어. 다들 넋을 놓고 보고 있단다. …너는 저기 올라갈 생각이지?'],
    ['땅 밑에 그런 게 있었다니. 이 마을은 대체 무엇 위에 서 있었던 걸까.'],
    ['별을 쫓아온 게 왔다더구나. …무엇이 무서워서 별이 도망쳤는지, 이제야 알겠어.',
     '다녀와. 돌아올 자리는 내가 지키고 있을게. 그게 내 일이야.'],
    ['벽돌에 정 자국이 하나도 없어. 보린이 그걸 보고 한참을 앉아 있었단다.',
     '사람이 안 지은 집에 사람이 들어와 사는 거지. …나쁘다는 건 아니야. 이상할 뿐이지.'],
    ['아래에서 뭘 보고 왔는지 네 얼굴에 다 적혀 있구나.',
     '몇백 년을 아무도 안 시켰는데 계속 일했다고? …그건 부지런한 게 아니라 외로운 거야.'],
    ['열흘 만에 마을이 달라졌어. 좋기도 하고 무섭기도 하고.',
     '어제는 빨래하다가 문득 손이 할 일이 없더구나. 그게 왜 서운했을까.'],
    ['발밑이 계속 울려. 밤에 자다가도 그 소리에 깬단다.',
     '아래에 또 하나 있다는 말은… 그 아래에도 있다는 말이겠지.'],
    ['천 년을 혼자 돌았다고 했지. 나는 넉 달을 혼자 있었는데도 미칠 것 같았어.',
     '가서 말해 줘. 위에 사람이 있다고. 그 말을 기다린 것 같으니까.'],
    ['만들다 만 사람들이라니. …그럼 완성된 건 무엇이 달랐던 걸까.',
     '돌아오면 이 마을에 이름을 붙이자. 잿빛도, 여명도 말고 — 우리가 지은 이름으로.']
  ],
  borin: [
    ['망치질 소리가 반갑지? 나도 그래. 요즘 이 소리 말고는 다 죽은 소리뿐이야.',
     '광석을 가져와. 뭐든 만들어 줄 테니.'],
    ['구리는 무르지만 없는 것보단 낫지. 철을 찾으면 바로 와.',
     '아, 그리고 — 짐승 가죽이나 뼈도 버리지 마. 그런 걸로도 만들 수 있는 게 있어.'],
    ['묘실 아래는 내가 못 가. 무릎이 예전 같지 않아서.',
     '대신 이건 알아 둬. 거기 뼈들은 살아 있는 게 아니야. 꿈꾸는 중인 거지.'],
    ['부패한 정수는 손대기 싫군. 만지면 손끝이 저려.',
     '그래도 미스릴은 그걸로만 정련돼. 세상이 참 얄궂어.'],
    ['얼음 송곳니를 가져왔군. 이런 건 벼리는 게 아니라 붙잡아 두는 거야.'],
    ['미스릴은 차갑고 가벼워. 네게 잘 어울리는 금속이야.',
     '…그 손, 점점 더 빛나는 것 같은데. 아프진 않나?'],
    ['에테르라는 걸 가져왔더군. 망치가 닿기도 전에 모양이 잡혀. 무섭더군.'],
    ['유적 벽돌은 내 화로로도 안 녹아. 우리보다 잘 만들었어, 그 사람들.'],
    ['별을 쫓아온 것이라. …벼려서 될 상대가 아닌 건 나도 안다.',
     '그래도 하나 만들어 놨어. 가져가. 내가 할 수 있는 건 이것뿐이야.'],
    ['벽돌 하나 떼어 봤는데 이음매가 없어. 통째로 나온 거야, 이게.',
     '나는 평생 두드려서 붙였는데. …여긴 붙일 데가 없어.'],
    ['무릎만 아니었으면 나도 내려갔을 거다. 그런 화로는 평생에 한 번 볼까 말까야.',
     '올라오거든 하나만 말해 줘. 불은 무엇으로 때더냐.'],
    ['대장간 옆에 낯선 게 자꾸 늘어. 나쁘진 않아. 다만…',
     '내 망치 소리가 저것들 소리에 묻혀. 그게 좀 서운하다.'],
    ['아래에서 저 혼자 늘어난다고? 쇠가 새끼를 친다는 말은 처음 듣는다.',
     '나는 하나 만들려고 사흘을 두드려. 그 사흘이 다행인 거였구나.'],
    ['사람이 손으로 만든 마지막 기계라고 했지. …그럼 그건 내 쪽 일이다.',
     '부수지 말고 말부터 걸어 봐. 만든 사람 대신 내가 부탁한다.'],
    ['사람 설계도라니. 키랑 손 길이까지 적혀 있었다며.',
     '나는 사람은 못 만들어. 대신 사람이 쓸 걸 만들지. …그걸로 됐다고 생각해.']
  ],
  mira: [
    ['네 안에서 별빛이 나. 알고 있었어?',
     '별이 부서질 때 조각 하나의 빛이 네게 박힌 거야. 그래서 네가 다른 조각을 만져도 꿈에 먹히지 않아.',
     '…대신 그 빛은 계속 타고 있어. 다 타기 전에 다섯을 모아야 해.'],
    ['조각은 잠들면 꿈을 꿔. 그 꿈이 주변에게 "너는 무엇이었지?"를 잊게 만들고.',
     '늪의 조각은 외롭지 않기를 꿈꿨어. 그래서 계속 갈라지는 거야.'],
    ['묘실의 조각은 제 꿈을 꾸지 않았어. 그 아래 잠든 것들의 꿈을 대신 꿨지.',
     '그러니 그건 악의가 아니야. 그냥… 잘못 꾼 꿈이야.'],
    ['숲의 조각은 굶주림을 꿈꿨어. 고치 속에서 날개가 자라기 전에 끝내야 해.'],
    ['실비아는 내 스승이야. 조각을 재우지 않고 삼십 년을 손에 쥐고 있었어.',
     '그게 어떤 건지 너는 곧 알게 될 거야. …부탁이 있어. 이야기라도 들어 줘.'],
    ['다섯 번째는 가장 깊이 떨어졌어. 하필 별이 도망쳐 온 그 자리로.',
     '그 조각은 꿈을 꿀 필요가 없었어. 다른 게 대신 썼거든.'],
    ['구름 위에서 마력이 흘러내려. 저건 자연이 만든 게 아니야. 설계된 거야.'],
    ['석판을 읽었어? …그럼 이제 알겠지. 우리가 처음이 아니라는 걸.'],
    ['조각 다섯이 다 모였는데 네 손의 별빛이 아직 안 꺼졌네.',
     '…그건 다 탄 게 아니라, 다 탈 필요가 없어졌다는 뜻이야.'],
    ['이 도시엔 꿈이 없어. 잿빛도 없고.',
     '잠든 적이 없는 거야. 계속 깨어서 돌기만 했어. 조각보다 그게 더 무서워.'],
    ['멈출 권한은 있는데 멈출 이유는 못 배웠다니.',
     '조각은 잘못 꿈꿔서 그랬지. 저건 꿈도 안 꿨어. 어느 쪽이 더 나쁜지 모르겠다.'],
    ['너무 빨라. 빠른 게 나쁜 게 아니라, 빠른 다음에 뭐가 오는지 우리가 방금 보고 왔잖아.',
     '케이드한테 뭐라고는 안 할 거야. 저 애 눈이 지금 제일 밝거든.'],
    ['3,400번을 혼자 결재했대. 아무도 안 물어봤으니까.',
     '나도 스승한테 그렇게 배웠어. 혼자 정하면 안 되는 걸 혼자 정하면… 실비아처럼 돼.'],
    ['멈추면 아무도 안 남는다는 걸 알아서 안 멈춘 거야. 그건 고집이 아니라 지킨 거지.',
     '가서 대답해 줘. 이번엔 남는다고. 그 말을 천 년 동안 기다린 거니까.'],
    ['사람을 그려서 만들었다는 게, 나는 별 조각 얘기보다 어려워.',
     '그런데 그 도면에 우리 손은 안 그려져 있었대. 그럼 우리는 저 사람들이 못 그린 쪽인 거야.']
  ],
  old: [
    ['…별은 떨어진 게 아니야. 도망쳐 온 게지.',
     '무엇으로부터인지는 묻지 마라. 입에 올리면 그것이 이쪽을 본다.'],
    ['외롭지 않기를 꿈꾸는 게 그렇게 나쁜 일이더냐. …그래도 죽여야지. 알고 있다.'],
    ['아래에 있는 건 왕이 아니다. 왕이라고 불릴 뿐이지.'],
    ['숲이 먹는 걸 탓하지 마라. 아무도 먹여주지 않았으니 제 몸을 먹는 것이다.'],
    ['실비아에게 내 안부를 전해 다오. …아니, 됐다. 그 애는 나를 기억 못 할 게다.'],
    ['다섯을 다 모으면 선택지가 하나 더 생길 게다. 지금은 그것만 알아 두어라.'],
    ['그래. 저 섬들은 내가 어릴 적에도 없었다. 없던 게 아니라, 안 보였던 게지.'],
    ['문을 열 셈이냐. …말리지 않으마. 나도 그때 그랬으니.'],
    ['드디어 그것이 왔구나. 나는 이 날을 여든 해 기다렸다.',
     '무섭거든 무섭다고 하거라. 그 말을 할 수 있는 것이 사람이다.'],
    ['이 도시를 나는 알고 있었다. 아무에게도 말하지 않았을 뿐이지.'],
    ['멈추라고 가르친 사람이 없었다니. …가르칠 사람이 먼저 멈춘 게지.'],
    ['빠른 것이 나쁘다는 말이 아니다. 손 뗄 자리를 같이 만들지 않은 것이 나쁜 게다.'],
    ['셋, 넷, 그리고 또 셋. 세다 보면 끝이 없다. 세지 말고 끊어라.'],
    ['그 아이는 명령을 어긴 것이 아니다. 지킨 게다. 그 둘이 같아 보이는 날이 있다.'],
    ['…나도 그 방을 본 적이 있다. 아주 어렸을 적에.',
     '무엇을 보았느냐고는 묻지 마라. 그때 나는 아무것도 이해하지 못했으니까.',
     '이제는 네가 보았으니, 나보다 네가 더 안다.']
  ],

  /* ---- 여명 마을 다섯 (9장부터 세계에 존재한다) ---- */
  tamer: [null, null, null, null, null, null, null, null, null,
    ['애들이 이 도시를 안 좋아해. 냄새가 없대.',
     '짐승은 사람 살던 자리 냄새를 맡거든. 여긴 그게 없어.'],
    ['네가 아래에서 올라온 날, 우리 애들이 전부 문 쪽만 보고 있었어.',
     '뭘 들은 거야. 나는 못 들었는데.'],
    ['기계 소리에 애들이 익숙해지는 중이야. 사람보다 빨라.',
     '…나는 아직 안 익숙해졌는데.'],
    ['땅이 울리는 날엔 알이 안 깨. 이유는 몰라.',
     '그냥 기다려. 아래가 조용해지면 깰 거야.'],
    ['짐승도 혼자 오래 두면 이상해져. 돌기만 하고 안 먹어.',
     '천 년이면… 그건 짐승한테 할 짓이 아니야. 기계라고 다를까.'],
    ['오늘 처음으로 애들이 지하 쪽으로 안 짖었어.',
     '아래가 비었다는 걸 나보다 먼저 알더라.']
  ],
  trainer: [null, null, null, null, null, null, null, null, null,
    ['벽이 단단해. 훈련용으로 이보다 나은 게 없다.',
     '…그런데 이 벽을 세운 놈들은 어디서 훈련했을까.'],
    ['기계를 상대할 땐 힘을 아껴라. 지치지 않는 쪽이 이기는 게 아니라, 먼저 멈추는 쪽이 지는 거다.'],
    ['마을에 기계가 늘수록 몸 쓰는 놈이 준다. 나는 그게 제일 걱정이다.',
     '편해지는 건 좋아. 약해지는 건 다른 얘기고.'],
    ['하나를 끄면 둘이 켜진다고? 그럼 세는 걸 그만둬라.',
     '세지 말고 근원을 쳐. 전장에선 그게 유일한 셈법이다.'],
    ['천 년을 버틴 놈이다. 자세가 무너질 리 없어.',
     '이길 생각 말고 버틸 생각을 해라. 저쪽이 먼저 대답할 거다.'],
    ['사람 모양으로 만든 건 사람처럼 싸운다. 그게 제일 까다로워.',
     '겁먹은 걸 보게 될 거다. …겁먹은 상대를 베는 데는 익숙해지지 마라.']
  ],
  haran: [null, null, null, null, null, null, null, null, null,
    ['방이 백 개인데 문고리가 하나도 안 닳았어.',
     '사람이 안 살았다는 뜻이지. 여관 주인은 문고리부터 봐.'],
    ['아래 내려간 사람들 몫으로 방을 비워 뒀어. 안 쓰면 그냥 비워 두는 거고.'],
    ['손님이 늘었어. 기계 보러 온 사람들이야.',
     '먼 데서도 소문이 도나 봐. 굴뚝은 멀리서도 보이니까.'],
    ['요즘은 밤에 잔이 저 혼자 떨려. 손 안 댔는데.',
     '땅이 우는 거지. 술 탓이 아니야.'],
    ['오늘 아래로 가는 사람한테는 방값 안 받아. 돌아와서 내.',
     '그게 내가 아는 유일한 부적이야.'],
    ['돌아온 사람 수가 나간 사람 수랑 같아. 처음이야, 이런 날.',
     '오늘은 문을 안 잠글게.']
  ],
  seira: [null, null, null, null, null, null, null, null, null,
    ['이 도시 강철은 두드려도 안 늘어나. 이미 다 정해진 모양이야.',
     '나는 모양을 바꾸는 게 일인데, 여긴 바꿀 게 없네.'],
    ['공창 것 하나만 가져와 봐. 뜯어서 안을 보고 싶어.',
     '만든 사람 솜씨는 겉이 아니라 안을 봐야 알아.'],
    ['풍차 덕에 밤에도 불을 살려 둬. 자면서도 벼릴 수 있겠다 싶더라.',
     '…그 생각 하고 나서 좀 무서워졌어. 자면서 일하는 건 기계 쪽이잖아.'],
    ['저 아래 것들은 저를 복사한다며. 나는 하나 벼리는 데 하루가 걸려.',
     '그런데 내가 만든 건 내가 이름을 붙이잖아. 그건 못 하겠지, 걔들은.'],
    ['천 년 된 쇠는 어떻게 생겼을까. …궁금해하면 안 되는 거 아는데.'],
    ['보린이 도면 한 장을 걸어 뒀더라. 사람 그림이래.',
     '그 앞에 한참 서 있었어. 벼릴 수 없는 걸 처음 봤거든.']
  ],
  kade: [null, null, null, null, null, null, null, null, null,
    ['이 도시, 사람이 지은 게 아니야. 그럼 누가 지었냐고? 그걸 알아내는 게 내 일이고.',
     '분수 아래 통로 봤지. 바닥이 안 보여. …좋은 신호는 아닌데, 나는 신나.'],
    ['관리자가 마지막에 뭐라고 했는지 알아? "1,140일 만입니다."',
     '천 년을 기다린 게 아니라 천 년을 센 거야. 그게 더 소름 끼쳐.'],
    ['봤어? 동력줄만 뽑으면 끝이야. 별거 아니라니까.',
     '…미라가 그 말 듣고 표정이 안 좋았어. 나도 알아. 이번엔 별거 아니었을 뿐이지.'],
    ['증설을 결재할 사람이 없으면 자동 승인. 규정대로야.',
     '규정을 쓴 사람 잘못은 아니야. 자기가 없어질 거라고는 안 적었을 뿐이지.'],
    ['헤파는 「멈춰라」를 이해했어. 이해하고도 안 멈춘 거야.',
     '나라면 어땠을까 생각해 봤는데… 나도 안 멈췄을 것 같아.'],
    ['기계 설계도가 아니야. 사람 설계도야. 심장 위치까지 적혀 있어.',
     '우리가 그 도면에 있는지 없는지는 확인 안 할래. 어느 쪽이든 오늘 할 일은 안 바뀌니까.']
  ]
};
